import { createFileRoute } from '@tanstack/react-router'

import UnauthorizedPage from '@/components/pages/UnauthorizedPage'

export const Route = createFileRoute('/403')({
  component: UnauthorizedPage
})
